import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { initTheme } from '@/components/ThemeToggle';
import { maybeInitSentryFromConsent, SentryErrorBoundary } from '@/lib/observability';

initTheme();
maybeInitSentryFromConsent();

function ErrorFallback({ resetError }) {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'inherit',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>Niečo sa pokazilo</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 16, fontSize: 14 }}>
          Skús obnoviť stránku. Ak problém pretrváva, daj nám vedieť.
        </p>
        <button
          type="button"
          onClick={resetError}
          style={{
            padding: '10px 18px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--product-primary)',
            color: '#fff',
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Skúsiť znova
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SentryErrorBoundary fallback={ErrorFallback}>
    <App />
  </SentryErrorBoundary>
);
